<template>
  <div class="sidebar">
    <div class="filter">
      <figure class="image is-128x128 mb-2" style="margin: auto;">
        <img :src="require('@/assets/images/PNG/MyGymChecker-Logomark-PNG-BlackBlue.png')" alt="MyGymChecker Logo">
      </figure>
      <div>
        <h3 class="title is-3 has-text-centered">Facility List</h3>
        <div class="control has-icons-right">
          <input
            class="input is-rounded facilitySearch"
            type="text"
            placeholder="Search facilities"
            v-model="facilitySearch"
          />
          <span class="icon is-small is-right" style="padding-bottom: calc(0.5em - 1px);">
            <button
              class="delete is-small"
              @click="clearSearch()"
            ></button>
          </span>
        </div>
        <div class="facilityList">
          <div v-if="searchFacilities.length">
            <FacilityBox
              v-for="(facility, index) in searchFacilities"
              :key="index"
              :facility="facility"
              @update="updateSearch"
            />
          </div>
          <h2 class="subtitle has-text-centered" v-else>No facilities found!</h2>
        </div>
        <div class="columns is-multiline is-gapless">
          <div class="column has-text-centered">
            <button
              class="button is-large search-button slide-left my-4 w100"
              @click="clearFacilities($event)"
            >
              Reset
            </button>
          </div>
        </div>
      </div>
      <div v-if="selectedFacilities.length">
        <h3 class="title is-5">Selected facilities:</h3>
        <div class="tags">
          <span
            v-for="(facility, index) in selectedFacilities"
            :key="index"
            class="tag is-info is-light"
          >
            {{ facility.name
            }}<button
              class="delete is-small"
              @click="deleteTag(facility)"
            ></button>
          </span>
        </div>
      </div>
    </div>
    <div
      class="filter"
    >
      <h3 class="title is-5">Sort By:</h3>
      <button
        class="facility button is-rounded w100 mb-2"
        :class="{ 'active-facility': sortByReview }"
        @click="toggleSortByReview"
      >
        <span
          class="is-small is-left checkboxContainer"
        >
          <Checkbox :selected="sortByReview" />
        </span>
        <div class="longName ml-4">
          Average review
        </div>
      </button>
      <button
        class="button is-large search-button slide-left w100"
        @click="showSidebar()"
      >
        Close
      </button>
    </div>
  </div>
</template>

<script>
import FacilityBox from "../molecules/FacilityBox";
import Checkbox from "../atoms/Checkbox";
import { mapActions, mapState, mapMutations } from "vuex";

export default {
  data() {
    return {
      facilitySearch: "",
    };
  },
  computed: {
    ...mapState([
      "facilities",
      "sortByReview",
      "search_value",
      "selected_range",
    ]),
    searchFacilities() {
      let regex = new RegExp(this.facilitySearch, "gi");
      return this.facilities.filter((facility) => regex.test(facility.name));
    },
    selectedFacilities() {
      return this.facilities.filter((facility) => facility.selected);
    },
  },
  components: {
    FacilityBox,
    Checkbox,
  },
  methods: {
    ...mapActions([
      "showSidebar",
      "resetFacilities",
      "findAllGyms",
      "findGyms",
      "toggleSortByReview",
    ]),
    ...mapMutations(["storeGyms", "toggleFacility", "storeSearch"]),
    async updateSearch() {
      this.storeSearch(this.search_value);
      if (this.search_value) {
        await this.findGyms();
      } else {
        await this.findAllGyms();
      }
    },
    clearFacilities(event) {
      event.target.blur();
      this.resetFacilities();
    },
    deleteTag(facility) {
      this.toggleFacility(facility);
      this.updateSearch();
    },
    clearSearch(){
      this.facilitySearch = "";
    }
  },
};
</script>

<style scoped>
.longName {
  font-size: 1.1rem;
}

.is-rounded {
  border: 2px solid #dcdcdc;
}
.checkboxContainer {
  position: absolute;
  top: calc((100% - 20px) / 2) !important; 
  left: 2.5% !important;
}

.sidebar {
  position: fixed;
  top: 0;
  z-index: 101;
  height: 100vh;
  overflow: auto;
  background-color: #ffffff;
  box-shadow: 8px 0 20px 0px #808080;
  width: max(17vw, 17rem);
}

.facilitySearch {
  height: 2rem;
  margin-bottom: 1rem;
}

.filter {
  margin-top: 0.5rem;
  margin-left: 1vw;
  width: 90%;
  height: auto;
  align-items: center;
}

.facilityList {
  width: 100%;
  max-height: 25rem;
  overflow-y: auto;
}

/* div.facilityList::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}

div.facilityList::-webkit-scrollbar {
  width: 12px;
  background-color: #f5f5f5;
}

div.facilityList::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #00c5fd;
} */

@media only screen and (max-width: 768px){
  .sidebar {
    width: 100vw;
  }

  .filter{
    width: 90%;
    margin-left: 5%;
  }
}
</style>
